<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigil_not_in_toc">Allan Quatermains Abenteuer</h2>
<h1 id="sigil_toc_id_1">Die heilige Blume</h1>
<h2 class="author sigil_not_in_toc">H. Rider Haggard</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1eab1526